module.exports = __webpack_public_path__ + "static/media/trafalgar.7d55bafb.png";